import React, { useState, useEffect } from "react";
import './Deeplink.css';
import useAuth from "../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";

const HEADER_HEIGHT = 56;

const DeeplinkGroup = () => {

	const [groupInfo, setGroupInfo] = useState([]);
	const { hashLinkId: hashLinkId } = useParams();
	const { sidebarOpen, getApi, postApi } = useAuth();
	const [loading, setLoading] = useState(true);


	const handleEnterGroup = () => {
		addIncrementStats('click_count').then(() => {
			if (groupInfo.invite_url) {
				redirectToWhatsapp(groupInfo.invite_code)
			}
		});

	};

	const handleCopy = async () => {
		try {

			addIncrementStats('click_count');
			await navigator.clipboard.writeText(groupInfo.invite_url);
			alert('Link copiado para a área de transferência');
		} catch (err) {
			alert('Falha ao copiar o link');
		}
	};


	useEffect(() => {


		if (hashLinkId) {
			loadGroupShowRequest();
			addIncrementStats('access_count')
		}

	}, [hashLinkId]);

	const loadGroupShowRequest = async () => {

		setLoading(true);
		try {
			let response = await getApi("/api/v1/campaign/groups/deeplink/" + hashLinkId, {
			});

			if (!response.id) {
				window.alert("Nenhum grupo disponível encontrdo");
				window.close();
				return;
			}
			setGroupInfo(response);
		} catch (error) {
			window.alert("Erro ao processar associação:", error);
			// Aqui você pode tratar o erro (ex: toast de aviso)
		} finally {

			setLoading(false);
		}
	}

	const redirectToWhatsapp = (inviteCode) => {
		const webLink = `https://chat.whatsapp.com/${inviteCode}`;
		const appLink = `whatsapp://chat?code=${inviteCode}`;

		// Tenta abrir o protocolo do App
		window.location.href = appLink;

		// Se após 500ms a página ainda estiver ativa, assume que o app não abriu
		// e redireciona para o link universal (web)
		setTimeout(() => {
			if (!document.hidden) {
				window.location.href = webLink;
			}
		}, 500);
	};



	const addIncrementStats = async (type) => {
		let response = await postApi("/api/v1/campaign/groups/stats/" + type + "/" + hashLinkId, {
		});
	}


	return (
		<div className="deeplink-page" style={{ paddingTop: HEADER_HEIGHT }}>
			<Helmet>
				<title>{groupInfo.name}</title>
			</Helmet>
			{loading &&
				<div style={{
					position: "fixed",
					top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.4)",
					zIndex: 9999,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}><Loader /></div>
			}

			<header className="deeplink-header">
			</header>

			<main className="deeplink-container" style={{ display: loading == true ? "none" : "flex" }}>
				<section className="deeplink-card">
					<div className="group-preview">
						<div className="group-cover">
							{groupInfo.picture_url ? (
								<img src={groupInfo.picture_url} alt="Capa do grupo" />
							) : (
								<div className="cover-placeholder"><i className="bi bi-image" /></div>
							)}
						</div>
						<h3 className="group-name">{groupInfo.name || 'Nome do Grupo'}</h3>
					</div>

					<div className="actions-vertical">
						<button className="btn btn-large primary" onClick={handleEnterGroup} disabled={!groupInfo.invite_url}>Entrar no Grupo</button>
						<button className="btn btn-large btn-copy" onClick={handleCopy} disabled={!groupInfo.invite_url}>Copiar o link do grupo</button>
					</div>

					<div className="instruction-text">
						<p>Se o acesso ao grupo não abrir automaticamente, faça o seguinte:</p>
						<p>abra o WhatsApp, cole o link em qualquer conversa e toque nele. Assim, você será direcionado diretamente para o grupo.</p>
					</div>
				</section>
			</main>
		</div>
	);
};

export default DeeplinkGroup;
